import { setJwtAuthKioskAxiosDomain } from "./management";
import jwtAuthAxios from "../auth/jwtAuth";

export const getCalculationsModel = async () => {
  let env = "stage";
  if (window.location.origin.includes("localhost")) {
    env = "dev";
  }
  setJwtAuthKioskAxiosDomain(jwtAuthAxios, env);
  try {
    const { data } = await jwtAuthAxios.get("/dsok/calculations");
    return data;
  } catch (error) {
    throw error;
  }
};

export const saveCalculationsModel = async (model) => {
  let env = "stage";
  if (window.location.origin.includes("localhost")) {
    env = "dev";
  }
  setJwtAuthKioskAxiosDomain(jwtAuthAxios, env);
  try {
    const { data } = await jwtAuthAxios.put("/dsok/calculations", model);
    return data;
  } catch (error) {
    throw error;
  }
};
